<template>
    <div class="afu-mb-7">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'C1FormGroup',
    };
</script>
